module.exports = __webpack_public_path__ + "static/img/pro-0.cf9c313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-0.png
// module id = 9RS1
// module chunks = 1